<template>
    <div class="page">
        <div v-html="page.content"></div>
    </div>
</template>

<script>
    import PageService from "@/services/api/Page";
    export default {
        name: "Page",
        data: () => ({
            page: {}
        }),
        created() {
            PageService.getByQueryName(this.$route.params.queryName).then(data => {
                this.page = data
            });
        },
        methods: {

        }
    }
</script>